import { useEffect } from "react";
import { Button } from "react-bootstrap";
import toast from "react-hot-toast";
import { MdFullscreen } from "react-icons/md";
import useFetch from "../../../hooks/useFetch";
import request from "../../../utils/request";
import toggleFullscreen from "../../../utils/toggleFullScreen";
import { generateTokenPDF } from "./helpers/generateTokenPDF";
import { useAudioPlayback } from "./helpers/useAudioPlayback";
import { socket } from "./socket";

const ServiceListTokenGenerate = () => {
  const { playAudio } = useAudioPlayback();

  const { data: serviceListData, isLoading } = useFetch(() =>
    request.getAll("queue-management/service-list")
  );

  const { data: settingsData } = useFetch(() => request.getAll("settings"));
  const settingData = settingsData[0];

  const tokenGenerate = async (service) => {
    try {
      const res = await request.create("queue-management/service-list/token", {
        serviceId: service.id,
      });
      // console.log(res);
      if (res.status === "OK") {
        toast.success("Token Generated Successfully");
        generateTokenPDF(service, res.data, settingData);
        if (settingData?.service_token_sound === 1) {
          console.log("service_token_sound", settingData?.service_token_sound);
          socket.emit("newToken", res.data);
          playAudio(res.data.token, res?.data?.counter?.name);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    socket.on("updateTokens", (data) => {
      playAudio(data.currentToken, data.currentToken?.counter?.name);
    });

    socket.on("recallToken", (data) => {
      if (data) {
        playAudio(data.token, data.counter?.name);
      }
    });

    socket.on("prevTokenCalling", (data) => {
      console.log("prevTokenCalling", data);
      if (data) {
        playAudio(data.token, data.counter?.name);
      }
    });

    return () => {
      socket.off("updateTokens");
      socket.off("recallToken");
      socket.off("prevTokenCalling");
    };
  }, []);

  return (
    <div className="">
      <div className="d-flex justify-content-between  text-white p-4 bg-cyan">
        <div className="fs-3">Clincx Token</div>
        <div className="d-flex gap-3 align-items-center">
          <p className="m-0 p-0 fs-3">{settingData?.website_name}</p>
          <div className="cursor-pointer" onClick={toggleFullscreen}>
            <MdFullscreen size={40} />
          </div>
        </div>
      </div>
      <div className="container">
        <div className=" text-center d-flex flex-column justify-content-center  gap-2 mt-5">
          {serviceListData?.length > 0 &&
            serviceListData?.map((service) => (
              <div key={service.id}>
                <Button
                  className={`px-5 mb-4 fs-4 font-size-5 `}
                  size="lg"
                  variant="outline-cyan"
                  onClick={(e) => {
                    // generateTokenPDF(service, "CAL222");
                    tokenGenerate(service);
                  }}
                  style={{
                    width: "70rem",
                    height: "7rem",
                  }}
                >
                  {service?.name}
                </Button>
              </div>
            ))}
        </div>
      </div>
      <div className="text-center text-white p-4 bg-cyan position-absolute bottom-0 w-100">
        Powered By Clincx Medical Solution
      </div>
    </div>
  );
};
export default ServiceListTokenGenerate;
